import { GET_SHOP_CONFIG } from "../constants/endpoints";
import axiosClient from "./axios";

class fetchShopConfigService {
  static async fetchShopConfig(id: string) {
    return await axiosClient.get(`${GET_SHOP_CONFIG.replace("{id}", id)}`);
  }
}

export default fetchShopConfigService;
